import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProductCustomerDetails } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomerProductService extends TmsWebBaseEditCreateService<
  ProductCustomerDetails,
  ProductCustomerDetails
> {
  constructor() {
    super('CustomerProduct', $localize`Customer Products`);
  }

  getCustomersForProduct(id: string): Observable<ProductCustomerDetails[]> {
    return this.httpService.get<ProductCustomerDetails[]>(`${this.apiUrl}/CustomersForProduct?id=${id}`);
  }
}
